import React from 'react';
import { View, Text, StyleSheet, ViewStyle, TextStyle } from 'react-native';
import { SVG_COMPONENTS } from '@/assets/admin';
import { useAdminColors } from '@/hooks/admin/useAdminColors';
import { useThemedStyles } from '@/hooks/shared/useThemeColors';

type SvgKey = keyof typeof SVG_COMPONENTS;

interface InlineEmptyMessageProps {
  title: string;
  message?: string;
  icon?: SvgKey;
  iconSize?: number;
  iconColor?: string;
  containerStyle?: ViewStyle;
  titleStyle?: TextStyle;
  messageStyle?: TextStyle;
}

export const InlineEmptyMessage: React.FC<InlineEmptyMessageProps> = ({
  title,
  message,
  icon = 'EMPTY_MESSAGE',
  iconSize = 64,
  iconColor,
  containerStyle,
  titleStyle,
  messageStyle,
}) => {
  const styles = useStyles();
  const { redesign } = useAdminColors();
  const resolvedIconColor = iconColor ?? redesign.text.muted;
  const IconComponent = SVG_COMPONENTS[icon];

  return (
    <View style={[styles.container, containerStyle]}>
      {!!IconComponent && (
        <IconComponent width={iconSize} height={iconSize} color={resolvedIconColor} style={styles.icon} />
      )}
      <Text style={[styles.title, titleStyle]}>{title}</Text>
      {message ? <Text style={[styles.message, messageStyle]}>{message}</Text> : null}
    </View>
  );
};

const useStyles = () =>
  useThemedStyles(({ components, colors }) => {
    const admin = components.admin;
    return StyleSheet.create({
      container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 24,
      },
      icon: {
        marginBottom: 16,
      },
      title: {
        fontSize: 16,
        fontWeight: '600',
        color: admin.dataTable.text,
        textAlign: 'center',
        marginBottom: 8,
      },
      message: {
        fontSize: 14,
        color: colors.text.dim,
        textAlign: 'center',
        lineHeight: 20,
        maxWidth: 300,
      },
    });
  });
